<div class="horizontal grid-container">
  <div class="col">
    <div class=" sub-header ">Writings</div>
    <div class="list">
      <a
        href="https://medium.com/@issaczting/i-built-a-sci-fi-style-portfolio-website-53cb6ac440b2#cee4-d0ecd5abb8c8"
      >
        Here's how I made this website. <br />
        <span class="sub-text">Published in Bootcamp</span>
      </a>
      <span class="date">05.2022</span>
    </div>
    <div class="list">
      <a
        href="https://medium.com/@issaczting/welcome-to-the-age-of-design-industrialization-let-me-explain-344c38196da7"
      >
        Welcome to the age of Design Industrialization. Let me explain…
      </a>
      <span class="date">12.2021</span>
    </div>
    <div class="list">
      <a
        href="https://medium.com/@issaczting/creating-micro-interactions-for-beginners-2eb31c48c689"
      >
        Creating micro-interactions for beginners
      </a>
      <span class="date">09.2018</span>
    </div>
    <div class="list">
      <a
        href="https://medium.com/@issaczting/a-simple-tutorial-on-interactive-animations-e41ded01cf66"
      >
        A simple tutorial on Interactive Animations
      </a>
      <span class="date">09.2018</span>
    </div>
  </div>
  <div class="col">
    <div class="  sub-header">Figma Community</div>
    <div class="list">
      <a href="https://www.figma.com/community/plugin/1032111792919656443">
        Markers - <span class="sub-text"> Figma Plugin</span>
      </a>
      <span class="date">11.2021</span>
    </div>
    <div class="list">
      <a href="https://www.figma.com/community/file/1081845377665077907">
        SCIFI KIT - <span class="sub-text"> Figma UI kit</span>
      </a>
      <span class="date">03.2022</span>
    </div>
    <div class="list">
      <a href="https://www.figma.com/community/file/1085496823591867207">
        Elden Ring Themed Retro. <br />
        <span class="sub-text"> Bring the game to your team. </span>
      </a>
      <span class="date">04.2022</span>
    </div>
  </div>
  <div class="col">
    <div class=" sub-header ">Talks</div>

    <div class="list">
      <a href="https://youtu.be/rmX55ODcYeI">
        Dating Tips 101 - <span class="sub-text"> A talk on CX </span>
      </a>
      <span class="date">12.2019</span>
    </div>

    <div class="list">
      <a href="https://youtu.be/ui2zG7kZxj4">
        The future of UX - <span class="sub-text">
          Why you should start a religion
        </span>
      </a>
      <span class="date">01.2021</span>
    </div>
    <br />
    <div class=" sub-header ">Resources</div>
    <div class="list">
      <a
        href="https://glossy-ink-3c8.notion.site/UX-Resource-e6b1726d50d944db8156e756c2731094"
      >
        UX Resources
      </a>
    </div>
  </div>
</div>

<style>
  .sub-header {
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 400;
  }
  .horizontal {
    flex-direction: row;
  }
  .sub-text {
    opacity: 0.5;
    font-size: 14px;
  }
  .date {
    margin-left: 10px;
    font-weight: 100;
    opacity: 0.5;
  }

  .grid-container {
    max-width: 1200px;
    margin: auto;
    padding: 20px 0px;
    color: white;
  }
  .body {
    font-weight: 100;
  }
  .col {
    width: 33%;
    margin: 24px;
  }
  .list {
    margin-top: 8px;
    display: flex;
    justify-content: space-between;
  }
  @media screen and (max-width: 800px) {
    .grid-container {
      flex-direction: column;
      background-color: rgb(26 26 26);
    }
    .col {
      width: auto;
    }
  }
</style>
